import { render, staticRenderFns } from "./ExibirTipoMandato.vue?vue&type=template&id=8fba88a2&scoped=true&"
import script from "./ExibirTipoMandato.vue?vue&type=script&lang=js&"
export * from "./ExibirTipoMandato.vue?vue&type=script&lang=js&"
import style0 from "./ExibirTipoMandato.vue?vue&type=style&index=0&id=8fba88a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fba88a2",
  null
  
)

export default component.exports